const PIXEL_ID =
  process.env.REACT_APP_OPENAI_ADS_PIXEL_ID || 'S1yBRHZa4oVHqd4bgTKxBi'
const DEBUG = process.env.REACT_APP_OPENAI_PIXEL_DEBUG === 'true'
const SDK_URL = 'https://bzrcdn.openai.com/sdk/oaiq.min.js'
const INITIALIZED_KEY = '__dripshipperOpenAiPixelInitialized'
const MEASURED_EVENTS_KEY = '__dripshipperOpenAiMeasuredEvents'

const installQueue = () => {
  if (window.oaiq) return

  const queue = function queue() {
    queue.q.push(arguments)
  }
  queue.q = []
  window.oaiq = queue

  const script = document.createElement('script')
  script.async = true
  script.src = SDK_URL
  const firstScript = document.getElementsByTagName('script')[0]

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}

export const initOpenAiPixel = () => {
  if (typeof window === 'undefined' || window[INITIALIZED_KEY]) return

  installQueue()
  window.oaiq('init', { pixelId: PIXEL_ID, debug: DEBUG })
  window[INITIALIZED_KEY] = true
}

export const identifyOpenAiUser = (user) => {
  if (typeof window === 'undefined' || !user) return

  initOpenAiPixel()
  window.oaiq('init', { user })
}

const measureOpenAiEvent = (eventName, conversion, fallbackData) => {
  if (typeof window === 'undefined') return false

  initOpenAiPixel()
  identifyOpenAiUser(conversion?.user)

  const deduplicationKey = conversion?.event_id || eventName
  if (!window[MEASURED_EVENTS_KEY]) window[MEASURED_EVENTS_KEY] = {}
  if (window[MEASURED_EVENTS_KEY][deduplicationKey]) return false
  window[MEASURED_EVENTS_KEY][deduplicationKey] = true

  const options = conversion?.event_id
    ? { event_id: conversion.event_id }
    : undefined
  if (options) {
    window.oaiq('measure', eventName, conversion?.data || fallbackData, options)
  } else {
    window.oaiq('measure', eventName, fallbackData)
  }

  return true
}

export const measureOpenAiRegistrationCompleted = (conversion) =>
  measureOpenAiEvent('registration_completed', conversion, {
    type: 'customer_action',
  })

export const measureOpenAiTrialStarted = (conversion) =>
  measureOpenAiEvent('trial_started', conversion, {
    type: 'plan_enrollment',
  })

const cookieValue = (name) =>
  document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith(`${name}=`))
    ?.split('=')
    .slice(1)
    .join('=')

const decoded = (value) => {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export const openAiAttributionHeaders = () => {
  if (typeof window === 'undefined') return {}

  const oppref =
    new URLSearchParams(window.location.search).get('oppref') ||
    cookieValue('__oppref')
  const obref = cookieValue('__obref')

  return {
    ...(oppref && { 'X-OpenAI-Oppref': decoded(oppref) }),
    ...(obref && { 'X-OpenAI-Obref': decoded(obref) }),
    'X-OpenAI-Source-Url': window.location.href,
  }
}

export const consumeOpenAiTrialConversion = () => {
  if (typeof window === 'undefined') return null

  const url = new URL(window.location.href)
  const encoded = url.searchParams.get('openai_conversion')
  const legacyAuthorized = url.searchParams.get('openai_trial_started') === '1'
  if (!encoded && !legacyAuthorized) return null

  let conversion
  if (encoded) {
    try {
      const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/')
      conversion = JSON.parse(window.atob(base64))
    } catch {
      conversion = undefined
    }
  }

  url.searchParams.delete('openai_conversion')
  url.searchParams.delete('openai_trial_started')
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`)

  if (
    encoded &&
    (!conversion?.event_id ||
      conversion?.event_name !== 'trial_started' ||
      conversion?.data?.type !== 'plan_enrollment')
  ) {
    return null
  }

  return { conversion }
}
